import { render, staticRenderFns } from "./action-frequency-selector.vue?vue&type=template&id=5d6b86b6&"
import script from "./action-frequency-selector.vue?vue&type=script&lang=js&"
export * from "./action-frequency-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./action-frequency-selector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports